import React from "react";
import AlignmentTile from "../../shared/AlignmentTile/AlignmentTile.component";
import { IPlan } from "../../interfaces/api";

const AlignmentsSection = ({ plans }: { plans: IPlan[] }) => {
  return (
    <div className="grid-container">
      <div className="show-for-large" style={{ padding: "0px 22px 16px 22px" }}>
        {plans?.map((dat, index) => (
          <AlignmentTile key={index} aligData={{ data: dat }} />
        ))}
      </div>
      <div className="hide-for-large" style={{ padding: "16px 0" }}>
        {plans?.map((dat, index) => (
          <AlignmentTile key={index} aligData={{ data: dat }} />
        ))}
      </div>
    </div>
  );
};

export default AlignmentsSection;
